import * as React from 'react';
import { Tooltip } from 'react-leaflet';
import { localizations } from '../localization/localization';
import { ApplicationState } from "../store";
import * as CompanyStore from '../companies/store/companyStore';
import { connect } from 'react-redux';
import { VisibleCompanyDataModel } from "../common/models/CommonModels";
import ZeckitSmallWidget from '../common/ZeckitSmallWidget';

const boldStyle = {
    fontWeight: 700
}

interface CompanyProps {
    company: CompanyStore.CompanyState
}

type CompanyTooltipProps = CompanyProps & VisibleCompanyDataModel;

const mapStateToProps = (state: ApplicationState) => {
    const company = state.visibleCompanies;
    return { company };
}

const CompanyTooltip: React.SFC<CompanyTooltipProps> = (props) => {
    return (
        <Tooltip offset={[15, -10]}>
            <div style={boldStyle}>{props.name}</div>
            { props.address &&
                <div>
                    <div>{props.address.streetAddress}</div>
                    <div>{`${props.address.postalCode} ${props.address.city}`}</div>
                </div>
            }
            <ZeckitSmallWidget businessId={props.businessId} maxWidth={50}/>
        </Tooltip>
    );
}

export default connect<any, any, any>(mapStateToProps)(CompanyTooltip);


// WEBPACK FOOTER //
// ./src/map/CompanyTooltip.tsx